// extracted by mini-css-extract-plugin
export default {"content":"style_content__lT83L","itemName":"style_itemName__VTkyo"};